/* Team K9 Donations page runtime. Progressive: the page reads fine without it (see .tkg-js in the CSS). */
(function () {
  "use strict";
  var root = document.querySelector("[data-tkg]");
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fmt = new Intl.NumberFormat("en-US");
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---- count-ups (small numbers: bars, receipt, chips) ---- */
  function countUp(el) {
    if (el.__tkgDone) return;
    el.__tkgDone = true;
    var end = parseFloat(el.getAttribute("data-count"));
    if (!isFinite(end)) return;
    var start = performance.now(), dur = Math.min(1600, 700 + end / 4);
    (function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      el.textContent = fmt.format(Math.round(end * (1 - Math.pow(1 - t, 3))));
      if (t < 1) requestAnimationFrame(tick);
    })(start);
  }

  /* ---- rolling numbers (the big figures): each digit is a column that rolls to its value ---- */
  function buildOdometer(el) {
    var text = el.textContent.trim();
    el.setAttribute("aria-label", text);
    el.textContent = "";
    el.classList.add("tkg-odo");
    var d = 0;
    text.split("").forEach(function (ch) {
      if (!/\d/.test(ch)) { var s = document.createElement("span"); s.textContent = ch; s.setAttribute("aria-hidden", "true"); el.appendChild(s); return; }
      var col = document.createElement("span"); col.className = "tkg-odo-col"; col.setAttribute("aria-hidden", "true");
      var strip = document.createElement("span"); strip.style.setProperty("--d", String(d)); d += 1;
      for (var n = 0; n <= 10 + Number(ch); n += 1) { var i = document.createElement("i"); i.textContent = String(n % 10); strip.appendChild(i); }
      strip.__to = 10 + Number(ch);
      col.appendChild(strip); el.appendChild(col);
    });
  }
  function rollOdometer(el) {
    Array.prototype.slice.call(el.querySelectorAll(".tkg-odo-col > span")).forEach(function (strip) { strip.style.transform = "translateY(-" + strip.__to + "em)"; });
  }

  /* ---- reveal on scroll ---- */
  var revealTargets = $$("[data-rv]");
  var odos = $$("[data-odo]");
  if ("IntersectionObserver" in window && !reduceMotion) {
    odos.forEach(buildOdometer);
    var rvIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        rvIO.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px 12% 0px", threshold: 0.01 });
    revealTargets.forEach(function (n) { rvIO.observe(n); });

    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (entry.target.hasAttribute("data-odo")) rollOdometer(entry.target); else countUp(entry.target);
        countIO.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    $$("[data-count]").concat(odos).forEach(function (n) { countIO.observe(n); });
  } else {
    revealTargets.forEach(function (n) { n.classList.add("is-in"); });
  }

  /* ---- the living painting: gold dust drifting up, and a slow tilt that follows the pointer ---- */
  var art = root.querySelector("[data-tkg-art]");
  var canvas = art && art.querySelector("canvas");
  if (art && canvas && canvas.getContext && !reduceMotion) {
    var ctx = canvas.getContext("2d"), motes = [], running = false, w = 0, h = 0, dpr = Math.min(2, window.devicePixelRatio || 1);
    function size() { var r = art.getBoundingClientRect(); w = r.width; h = r.height; canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function seed(m, fresh) { m.x = Math.random() * w; m.y = fresh ? Math.random() * h : h + 8; m.r = 0.8 + Math.random() * 2.2; m.v = 0.12 + Math.random() * 0.38; m.s = Math.random() * 6.28; m.a = 0.25 + Math.random() * 0.6; }
    function frame() {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < motes.length; i += 1) {
        var m = motes[i];
        m.y -= m.v; m.s += 0.012; m.x += Math.sin(m.s) * 0.25;
        if (m.y < -8) seed(m, false);
        ctx.globalAlpha = m.a * (0.6 + 0.4 * Math.sin(m.s * 2));
        ctx.fillStyle = "#b6f5e6";
        ctx.beginPath(); ctx.arc(m.x, m.y, m.r, 0, 6.2832); ctx.fill();
      }
      requestAnimationFrame(frame);
    }
    size();
    for (var k = 0; k < 34; k += 1) { var mote = {}; seed(mote, true); motes.push(mote); }
    window.addEventListener("resize", size);
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) { var on = e[0].isIntersecting; if (on && !running) { running = true; requestAnimationFrame(frame); } else if (!on) running = false; }, { threshold: 0 }).observe(art);
    } else { running = true; requestAnimationFrame(frame); }

    var hero = root.querySelector(".tkg-hero");
    if (hero && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      hero.addEventListener("pointermove", function (event) {
        var r = hero.getBoundingClientRect();
        var x = (event.clientX - r.left) / r.width - 0.5, y = (event.clientY - r.top) / r.height - 0.5;
        art.style.setProperty("--ry", (x * 9).toFixed(2) + "deg");
        art.style.setProperty("--rx", (-y * 7).toFixed(2) + "deg");
        art.style.setProperty("--px", (-x * 16).toFixed(1) + "px");
        art.style.setProperty("--py", (-y * 12).toFixed(1) + "px");
      });
      hero.addEventListener("pointerleave", function () { ["--rx", "--ry", "--px", "--py"].forEach(function (p) { art.style.removeProperty(p); }); });
    }
  }

  /* ---- the film: loads when near, plays muted while in view, sound is opt-in ---- */
  var film = root.querySelector("[data-tkg-film]");
  if (film) {
    var filmFrame = film.closest("[data-tkg-film-frame]");
    var filmToggle = root.querySelector("[data-tkg-film-toggle]");
    var filmSound = root.querySelector("[data-tkg-film-sound]");
    var filmSoundLabel = root.querySelector("[data-tkg-film-sound-label]");
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    var filmUserPaused = false;
    var filmLoad = function () {
      if (film.getAttribute("src")) return;
      var small = film.getAttribute("data-src-sm");
      var phone = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
      film.setAttribute("src", small && phone ? small : film.getAttribute("data-src"));
    };
    var filmPlay = function () {
      filmLoad();
      var p = film.play();
      if (p && p.catch) p.catch(function () {});
    };
    film.addEventListener("play", function () { filmFrame.classList.add("is-playing"); filmToggle.setAttribute("aria-label", "Pause the film"); });
    film.addEventListener("pause", function () { filmFrame.classList.remove("is-playing"); filmToggle.setAttribute("aria-label", "Play the film"); });
    filmToggle.addEventListener("click", function () {
      if (film.paused) { filmUserPaused = false; filmPlay(); } else { filmUserPaused = true; film.pause(); }
    });
    filmSound.addEventListener("click", function () {
      var on = film.muted;
      film.muted = !on;
      filmSound.setAttribute("aria-pressed", on ? "true" : "false");
      filmSoundLabel.textContent = on ? "Sound on" : "Tap for sound";
      if (on) { filmUserPaused = false; if (film.paused) filmPlay(); }
    });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          if (!filmUserPaused && !reduceMotion && !saveData) filmPlay();
        } else if (!film.paused) {
          film.pause();
        }
      }, { threshold: [0, 0.5, 1] }).observe(film);
    }
  }

  /* ---- sticky shop bar on phones: after the hero, hidden again once the closer is reached ---- */
  var sticky = root.querySelector("[data-tkg-sticky]");
  var heroEl = root.querySelector(".tkg-hero");
  var closerEl = root.querySelector(".tkg-closer");
  if (sticky && heroEl && "IntersectionObserver" in window) {
    sticky.hidden = false;
    var heroOut = false, closerIn = false;
    var sync = function () { sticky.classList.toggle("is-on", heroOut && !closerIn); };
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; sync(); }, { threshold: 0 }).observe(heroEl);
    if (closerEl) new IntersectionObserver(function (e) { closerIn = e[0].isIntersecting || e[0].boundingClientRect.top < 0; sync(); }, { threshold: [0, 0.2] }).observe(closerEl);
  }

  /* ---- the closing painting loads when the reader is within a screen or so of it ---- */
  var nearEl = root.querySelector(".tkg-closer");
  if (nearEl) {
    if ("IntersectionObserver" in window) {
      var nearIO = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { nearEl.classList.add("is-near"); nearIO.disconnect(); } }, { rootMargin: "1200px 0px" });
      nearIO.observe(nearEl);
    } else nearEl.classList.add("is-near");
  }

  /* ---- smooth scroll for the in-page jump ---- */
  $$('a[href^="#donations-"]').forEach(function (a) {
    a.addEventListener("click", function (event) {
      var target = document.getElementById(a.getAttribute("href").slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    });
  });
})();

/* Copy deterrent for the Donations and Community pages (same behaviour as the guard on Home, About and the guide pages).
   No right-click menu on pictures and plain text, no dragging pictures out, no selecting or copying page text. A
   right-click on a link or button is left alone, and FAQ answers can be selected. It slows casual copying; it cannot
   stop someone reading the page source. */
(function () {
  "use strict";
  if (window.__tk9GuardTkg) return;
  window.__tk9GuardTkg = true;
  var ROOT = ".tkg", OK = "input, textarea, select, [contenteditable], .tkg-faq-list, [data-copy-ok]";
  var el = function (n) { return n && n.nodeType === 1 ? n : n && n.parentElement; };
  var guarded = function (n) { n = el(n); return !!(n && n.closest(ROOT) && !n.closest(OK)); };
  document.addEventListener("contextmenu", function (e) {
    var n = el(e.target);
    if (!guarded(n)) return;
    var media = n.closest("img, video, picture, figure, [class*='-cast'], [class*='-peek']");
    if (media || !n.closest("a[href], button")) e.preventDefault();
  });
  document.addEventListener("dragstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("selectstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("copy", function (e) { var s = window.getSelection && window.getSelection(); if (s && s.rangeCount && guarded(s.anchorNode)) e.preventDefault(); });
})();

